import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Input, Button, Card, message, Layout } from 'antd';
import { UserOutlined, LockOutlined, HeartOutlined } from '@ant-design/icons';
import { adminAPI } from '../../utils/api';
import './AdminLogin.css';

const { Content } = Layout;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await adminAPI.login(values);
      if (response && response.success) {
        localStorage.setItem('adminToken', response.token);
        message.success('登录成功！');
        navigate('/XiaoXin/dashboard');
      } else {
        message.error(response?.message || '登录失败');
      }
    } catch (error) {
      message.error('登录失败：' + (error.message || '网络错误'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout className="admin-login-layout">
      <Content className="admin-login-content">
        <div className="admin-login-container">
          <div className="admin-login-header">
            <div className="admin-login-logo">
              <HeartOutlined className="admin-login-logo-icon" />
            </div>
            <h1 className="admin-login-title">RPI 管理后台</h1>
            <p className="admin-login-subtitle">恋爱占有欲指数测试系统</p>
          </div>

          <Card className="admin-login-card">
            <Form
              name="admin-login"
              onFinish={onFinish}
              autoComplete="off"
              size="large"
            >
              <Form.Item
                name="username"
                rules={[{ required: true, message: '请输入用户名' }]}
              >
                <Input 
                  prefix={<UserOutlined />} 
                  placeholder="用户名" 
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[{ required: true, message: '请输入密码' }]}
              >
                <Input.Password
                  prefix={<LockOutlined />}
                  placeholder="密码"
                />
              </Form.Item>

              <Form.Item>
                <Button 
                  type="primary" 
                  htmlType="submit" 
                  loading={loading}
                  block
                  className="admin-login-button"
                >
                  登录
                </Button>
              </Form.Item>
            </Form>
          </Card>

          <div className="admin-login-footer">
            <Button type="link" onClick={() => navigate('/')}>
              返回首页
            </Button>
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default AdminLogin;
